import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationTemplateService } from 'src/app/core/services/notification-template.service';
import { UtilService } from 'src/app/core/services/util.service';

@Component({
  selector: 'app-notification-template-dialog',
  templateUrl: './notification-template.component.html',
  styleUrls: ['./notification-template.component.scss']
})
export class NotificationTemplateDialogComponent {

  action: 'add' | 'edit' = 'add';
  form: FormGroup;
  submitting = false;

  constructor(
    public dialogRef: MatDialogRef<NotificationTemplateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private templateService: NotificationTemplateService,
    private utilService: UtilService
  ) {
    this.action = data?.action || 'add';

    this.form = this.fb.group({
      approach: [data?.data?.approach || '', Validators.required],
      eventName: [data?.data?.eventRole?.split('#')[0] || '', Validators.required],
      role: [data?.data?.eventRole?.split('#')[1] || 'APPLICANT', Validators.required],
      subject: [data?.data?.subject || ''],
      title: [data?.data?.title || ''],
      body: [data?.data?.body || ''],
      enabled: [data?.data?.enabled ?? true],
      emailEnabled: [data?.data?.emailEnabled ?? true],
      inboxEnabled: [data?.data?.inboxEnabled ?? true],
    });

    if (this.action === 'edit') {
      this.form.get('approach')?.disable();
      this.form.get('eventName')?.disable();
      this.form.get('role')?.disable();
    }
  }

  submit() {
    if (!this.form.valid) return;
    this.submitting = true;

    const val = this.form.getRawValue();
    const payload = {
      approach: val.approach,
      eventRole: `${val.eventName}#${val.role}`,
      subject: val.subject,
      title: val.title || val.subject,
      body: val.body,
      enabled: val.enabled,
      emailEnabled: val.emailEnabled,
      inboxEnabled: val.inboxEnabled,
    };

    const request = this.action === 'add'
      ? this.templateService.createTemplate(payload)
      : this.templateService.updateTemplate(payload);

    request.subscribe({
      next: () => {
        this.utilService.openToastr('success', `Template ${this.action === 'add' ? 'created' : 'updated'}`);
        this.dialogRef.close(true);
      },
      error: () => {
        this.utilService.openToastr('error', `Failed to ${this.action} template`);
        this.submitting = false;
      }
    });
  }
}
